import { FETCH_METHODS, SearchConfig } from "./api.model"
import { DataTableSchema, DefaultTableSchema } from "./dynamic-data-table.model"
import { FieldNames } from "./form-fields.model"
import { BrandTenureHistory } from "./tenure/brand-tenure.model";
import { DealerTenureHistory } from "./tenure/dealers-tenure.model";
import { JobTenureHistory } from "./tenure/jobs-tenure.model";

const JobHistoryDetailTitle = "Job History Detail"
const FirstName = "FIRST NAME";
const DealerCode = "DEALER CODE";
const DealerName = "DEALER NAME";
const BeginDate = "BEGIN DATE";
const BrandTenure ="BRAND TENURE";
const TenureHistory = "Tenure History";
const ClockRotateIcon ="fa-solid fa-clock-rotate-left";
const FaIconCheckered ="fa-solid fa-clock-rotate-left";
const NoHistory = "No History";
const JobTenure = "JOB TENURE";
export const JobHistoryDetailDbKeys = {
    EndDate: "endDate",
    JobEndDate:'jobEndDate'
}

const tenureHistorySearchConfig:SearchConfig = {
    method: FETCH_METHODS['Post'],
    path: "getTenureHistory"
}
export const tenureHistoryActionSearchConfig: Record<string, SearchConfig> = {
    lexusAssociateDetails: {
        ...structuredClone(tenureHistorySearchConfig),
        body: {
            [FieldNames['SpinId']]: '',
            [FieldNames['Brand']]: 'LEXUS',
            "type": "brand"
        }
    },
    lexusDealerDetails: {
        ...structuredClone(tenureHistorySearchConfig),
        body: {
            [FieldNames['SpinId']]: '',
            [FieldNames['DealerCode']]: '',
            [FieldNames['Brand']]: 'LEXUS',
            "type": "dealer",
        }
    },
    lexusPrimaryJobDetails: {
        ...structuredClone(tenureHistorySearchConfig),
        body: {
            [FieldNames['SpinId']]: '',
            [FieldNames['DealerCode']]: '',
            [FieldNames['JobCode']]: '',
            [FieldNames['Brand']]: 'LEXUS',
            "type": "job"
        }
    },
    lexusSecondaryJobDetails: {
        ...structuredClone(tenureHistorySearchConfig),
        body: {
            [FieldNames['SpinId']]: '',
            [FieldNames['DealerCode']]: '',
            [FieldNames['JobCode']]: '',
            [FieldNames['Brand']]: 'LEXUS',
            "type": "job"
        }
    },
    toyotaAssociateDetails: {
        ...structuredClone(tenureHistorySearchConfig),
        body: {
            [FieldNames['SpinId']]: '',
            [FieldNames['Brand']]: 'TOYOTA',
            "type": "brand"
        }
    },
    toyotaDealerDetails: {
        ...structuredClone(tenureHistorySearchConfig),
        body: {
            [FieldNames['SpinId']]: '',
            [FieldNames['DealerCode']]: '',
            [FieldNames['Brand']]: 'TOYOTA',
            "type": "dealer",
        }
    },
    toyotaPrimaryJobDetails: {
        ...structuredClone(tenureHistorySearchConfig),
        body: {
            [FieldNames['SpinId']]: '',
            [FieldNames['DealerCode']]: '',
            [FieldNames['JobCode']]: '',
            [FieldNames['Brand']]: 'TOYOTA',
            "type": "job"
        }
    },
    toyotaSecondaryJobDetails: {
        ...structuredClone(tenureHistorySearchConfig),
        body: {
            [FieldNames['SpinId']]: '',
            [FieldNames['DealerCode']]: '',
            [FieldNames['JobCode']]: '',
            [FieldNames['Brand']]: 'TOYOTA',
            "type": "job"
        }
    }
}

export const LexusAssociateSummaryTableSchema: DataTableSchema = {
    ...DefaultTableSchema,
    columnSchema: [
        { label: "SPIN ID", fieldKey: "spinId" },
        { label: "STATUS", fieldKey: "employeeStatus" },
        { label:  FirstName, fieldKey: "firstName" },
        { label: "LAST NAME", fieldKey: "lastName" },
        { label: "LEXUS HIRE DATE", fieldKey: "startDate" },
        { label:  DealerCode, fieldKey: "dealerCode" },
        { label:  DealerName, fieldKey: "dealerName" },
        { label: "IS PC", fieldKey: "isPC" },
        { label: BrandTenure, fieldKey: "brandTenure" },
        {
            label: TenureHistory, fieldKey: 'tenure_history_action', fieldType: 'Actions',
            actionConfig: [{
                fieldKey: BrandTenureHistory,
                dependentFieldName: 'brandTenureHistoryFlag',
                iconClass: ClockRotateIcon,
                alt:NoHistory,
                toolTip: 'History'
            }]
        }
    ],
    exportConfig:{
        fileName:'',
        schema:{
            spinId:"SPIN ID",
            employeeStatus:"STATUS",
            firstName: FirstName,
            lastName:"LAST NAME",
            startDate:"LEXUS HIRE DATE",
            dealerCode: DealerCode,
            dealerName: DealerName,
            isPC: "IS PC",
            brandTenure: BrandTenure
        }
    },
    isExportRequired: false,
    isSearchRequired: false,
    isPaginationRequired: false,
    breadcrums: [{ level: 1, name: JobHistoryDetailTitle }]
}

export const LexusDealerStatusTableSchema: DataTableSchema = {
    ...DefaultTableSchema,
    columnSchema: [
//           { label: "", fieldKey: "buySellFlag",fieldType: 'Actions', actionConfig: [
//             {   
//                 fieldKey: "isBuySell",
//                 iconClass: FaIconCheckered,
//                 toolTip: 'Buy/Sell - Old Dealer',
//                 color:'#00f',
//                 dependentFieldName: 'buySellOldDealer',      
//             },
//             {
//                 fieldKey: "isBuySell",
//                 iconClass: FaIconCheckered,
//                 toolTip: 'Buy/Sell - New Dealer',
//                 color:'#00f',
//                 dependentFieldName: 'buySellNewDealer',      
//             }
//         ]
//         },
        { label: "AREA", fieldKey: "areaName", isNotCamelCase:true },
        { label: "DISTRICT", fieldKey: "district" },
        { label: "IS PRIMARY", fieldKey: "primaryRole" },
        { label:  DealerCode, fieldKey: "dealerCode" },
        { label:  DealerName, fieldKey: "dealerName" },
        { label: "FROM DATE", fieldKey: "startDate" },
        { label: "TO DATE", fieldKey: JobHistoryDetailDbKeys['EndDate'], isNotCamelCase:true},
        { label: "DEALER TENURE", fieldKey: "dealerTenure" },
        {
            label: TenureHistory, fieldKey: 'tenure_history_action', fieldType: 'Actions',
            actionConfig: [{
                fieldKey: DealerTenureHistory,
                dependentFieldName: 'dealerTenureHistoryFlag',
                iconClass: ClockRotateIcon,
                alt:NoHistory,
                toolTip: 'History'
            }]
        }
    ],
    isExportRequired: false,
    isSearchRequired: false,
    isPaginationRequired: false,
    breadcrums: [{ level: 1, name: JobHistoryDetailTitle }]
}

export const LexusEnrollmentStatusTableSchema: DataTableSchema = {
    ...DefaultTableSchema,
    columnSchema: [
        { label: "PRIMARY JOB CODE", fieldKey: "jobCode" },
        { label: "PRIMARY JOB CODE DESC", fieldKey: "jobDescription" },
        { label: "LEXUS PRIMARY DEALER CODE", fieldKey: "dealerCode" },
        { label:  BeginDate, fieldKey: "startDate" },
        { label: "END DATE", fieldKey: JobHistoryDetailDbKeys['EndDate'], isNotCamelCase:true },
        { label: JobTenure, fieldKey: "jobTenure" },
        {
            label: TenureHistory, fieldKey: 'tenure_history_action', fieldType: 'Actions', 
            actionConfig: [
                {
                    fieldKey: JobTenureHistory,
                    iconClass: ClockRotateIcon,
                    dependentFieldName: 'jobTenureHistoryFlag',
                    alt:NoHistory,
                    toolTip: 'History'
                }]
        },
    ],
    isExportRequired: false,
    isSearchRequired: false,
    isPaginationRequired: false,
    breadcrums: [{ level: 1, name: JobHistoryDetailTitle }]
}

export const LexusSecondaryJobRoleTableSchema: DataTableSchema = {
    ...DefaultTableSchema,
    columnSchema: [
        { label: "SECONDARY JOB CODE", fieldKey: "jobCode" },
        { label: "SECONDARY JOB CODE DESC", fieldKey: "jobDescription" },
        { label: "DLR/DEPT Code", fieldKey: "dealerCode",isCamelCaseHeader:true },
        { label: BeginDate, fieldKey: "startDate" },
        { label: "END DATE", fieldKey: JobHistoryDetailDbKeys['EndDate'], isNotCamelCase:true },
        { label: JobTenure, fieldKey: "jobTenure" },
        {
            label: TenureHistory, fieldKey: 'tenure_history_action', fieldType: 'Actions', 
            actionConfig: [
                {
                    fieldKey: JobTenureHistory,
                    iconClass: ClockRotateIcon,
                    dependentFieldName: 'jobTenureHistoryFlag',
                    alt:NoHistory,
                    toolTip: 'History'
                }]
        }
    ],
    isExportRequired: false,
    isSearchRequired: false,
    isPaginationRequired: false,
    breadcrums: [{ level: 1, name: JobHistoryDetailTitle }]
}

export const LexusCertificationDetailsTableSchema: DataTableSchema = {
    ...DefaultTableSchema,
    columnSchema: [
        { label: "JOB CODE", fieldKey: "jobCode",isUpperCase:true},
        { label: "JOB CODE DESC", fieldKey: "jobCodeDescription" },
        { label: "CERT LEVEL", fieldKey: "certLevel" },
        { label: "CERT DATE", fieldKey: "certStartDate" },
    ],
    isExportRequired: false,
    isSearchRequired: false,
    isPaginationRequired: true,
    breadcrums: [{ level: 1, name: JobHistoryDetailTitle }]
}

export const ToyotaAssociateSummaryTableSchema: DataTableSchema = {
    ...DefaultTableSchema,
    columnSchema: [
        { label: "SPIN ID", fieldKey: "spinId" },
        { label: "STATUS", fieldKey: "employeeStatus" },
        { label:  FirstName, fieldKey: "firstName" },
        { label: "LAST NAME", fieldKey: "lastName" },
        { label: "TOYOTA HIRE DATE", fieldKey: "startDate" },
        { label:  DealerCode, fieldKey: "dealerCode" },
        { label:  DealerName, fieldKey: "dealerName" },
        { label:  BrandTenure, fieldKey: "brandTenure" },
        {
            label: TenureHistory, fieldKey: 'tenure_history_action', fieldType: 'Actions',
            actionConfig: [{
                fieldKey: BrandTenureHistory,
                dependentFieldName: 'brandTenureHistoryFlag',
                iconClass: ClockRotateIcon,
                toolTip: 'History',
                alt:NoHistory,
            }]
        }
    ],
    isExportRequired: false,
    isSearchRequired: false,
    isPaginationRequired: false,
    breadcrums: [{ level: 1, name: JobHistoryDetailTitle }]
}

export const ToyotaDealerStatusTableSchema: DataTableSchema = {
    ...DefaultTableSchema,
    columnSchema: [
//         { label: "", fieldKey: "buySellFlag",fieldType: 'Actions', actionConfig: [
//             {   
//                 fieldKey: "isBuySell",
//                 iconClass: FaIconCheckered,
//                 toolTip: 'Buy/Sell - Old Dealer',
//                 color:'#00f',
//                 dependentFieldName: 'buySellOldDealer',      
//             },
//             {
//                 fieldKey: "isBuySell",
//                 iconClass: FaIconCheckered,
//                 toolTip: 'Buy/Sell - New Dealer',
//                 color:'#00f',
//                 dependentFieldName: 'buySellNewDealer',      
//             }
//         ]
//         },
        { label: "Region", fieldKey: "areaName", isNotCamelCase:true },
        { label: "DISTRICT", fieldKey: "district" },
        { label: DealerCode, fieldKey: "dealerCode" },
        { label: DealerName, fieldKey: "dealerName" },
        { label: "FROM DATE", fieldKey: "startDate" },
        { label: "TO DATE", fieldKey: JobHistoryDetailDbKeys['EndDate'], isNotCamelCase:true },
        { label: "DEALER TENURE", fieldKey: "dealerTenure" },
        {
            label: TenureHistory, fieldKey: 'tenure_history_action', fieldType: 'Actions',
            actionConfig: [{
                fieldKey: DealerTenureHistory,
                dependentFieldName: 'dealerTenureHistoryFlag',
                iconClass: ClockRotateIcon,
                alt:NoHistory,
                toolTip: 'History'
            }]
        }
    ],
    isExportRequired: false,
    isSearchRequired: false,
    isPaginationRequired: false,
    breadcrums: [{ level: 1, name: JobHistoryDetailTitle }]
}

export const ToyotaEnrollmentStatusTableSchema: DataTableSchema = {
    ...DefaultTableSchema,
    columnSchema: [
        { label: "JOB CODE", fieldKey: "jobCode" },
        { label: "PRIMARY JOB CODE DESC", fieldKey: "jobDescription" },
        { label: "TOYOTA DEALER CODE", fieldKey: "dealerCode" },
        { label:  BeginDate, fieldKey: "jobStartDate" },
        { label: "END DATE", fieldKey: JobHistoryDetailDbKeys['JobEndDate'], isNotCamelCase:true },
        { label: JobTenure, fieldKey: "jobTenure" },
        {
            label: TenureHistory, fieldKey: 'tenure_history_action', fieldType: 'Actions', 
            actionConfig: [
                {
                    fieldKey: JobTenureHistory,
                    iconClass: ClockRotateIcon,
                    dependentFieldName: 'jobTenureHistoryFlag',
                    alt:NoHistory,
                    toolTip: 'History'
                }]
        },
    ],
    isExportRequired: false,
    isSearchRequired: false,
    isPaginationRequired: false,
    breadcrums: [{ level: 1, name: JobHistoryDetailTitle }]
}
export const ToyotaSecondaryJobRoleTableSchema: DataTableSchema = {
    ...DefaultTableSchema,
    columnSchema: [
        { label: "SECONDARY JOB CODE", fieldKey: "jobCode" },
        { label: "SECONDARY JOB CODE DESC", fieldKey: "jobDescription" },
        { label: "DLR/DEPT Code", fieldKey: "dealerCode",isCamelCaseHeader:true },
        { label: BeginDate, fieldKey: "jobStartDate" },
        { label: "END DATE", fieldKey: JobHistoryDetailDbKeys['JobEndDate'], isNotCamelCase:true },
        { label: JobTenure, fieldKey: "jobTenure" },
        {
            label: TenureHistory, fieldKey: 'tenure_history_action', fieldType: 'Actions', 
            actionConfig: [
                {
                    fieldKey: JobTenureHistory,
                    iconClass: ClockRotateIcon,
                    dependentFieldName: 'jobTenureHistoryFlag',
                    alt:NoHistory,
                    toolTip: 'History'
                }]
        },
    ],
    isExportRequired: false,
    isSearchRequired: false,
    isPaginationRequired: false,
    breadcrums: [{ level: 1, name: JobHistoryDetailTitle }]
}
export const ToyotaCertificationDetailsTableSchema: DataTableSchema = {
    ...DefaultTableSchema,
    columnSchema: [
        { label: "JOB CODE GROUP", fieldKey: "jobCodeDescription" ,isUpperCase:true },
        { label: "CERT LEVEL", fieldKey: "certLevel" },
        { label: "CERT TYPE", fieldKey: "certType",isUpperCase:true},
        { label: "CERT DATE", fieldKey: "certStartDate" },
        { label: "FROM DATE", fieldKey: "fromDate" },
        { label: "To DATE", fieldKey: "toDate" }        
    ],
    isExportRequired: false,
    isSearchRequired: false,
    isPaginationRequired: true,
    breadcrums: [{ level: 1, name: JobHistoryDetailTitle }]
}
 
export const TTENTableSchema: DataTableSchema = {
    ...DefaultTableSchema,
    columnSchema: [
        { label: "SPIN ID", fieldKey: "spinId", isSortable: false },
        { label: FirstName, fieldKey: "firstName", isSortable: false },
        { label: "LAST NAME", fieldKey: "lastName", isSortable: false },
        { label: "T-TEN DEALER", fieldKey: "dealerCode", isSortable: false },
        { label: "JOB CODE", fieldKey: "jobCode", isSortable: false },
        { label: "JOB DESC", fieldKey: "jobDescription", isSortable: false },
        { label: "Lexus Brand Tenure", fieldKey: "lexusTenure", isSortable: false },
        { label: "Toyota Brand Tenure", fieldKey: "toyotaTenure", isSortable: false },
        { label: "T-TEN Tenure", fieldKey: "tTenTenure", isColumnsMerge: true, isSortable: false },
    ],
    isExportRequired: false,
    isSearchRequired: false,
    isPaginationRequired: false,
    breadcrums: [{ level: 1, name: "T-TEN Dealers" }]
}

export type jobHistoryDetailTableSchema = {
    headerLabel: string,
    tableSchemaArray: Array<{ title: string, schema: DataTableSchema, dataKey: string }>
}

export const JobHistoryDetailComponentLexusTableSchema: jobHistoryDetailTableSchema = {
    headerLabel: "LEXUS",
    tableSchemaArray: [
        {
            title: "Associate Summary",
            dataKey: 'lexusAssociateDetails',
            schema: LexusAssociateSummaryTableSchema
        },
        {
            title: "Dealer Status",
            schema: LexusDealerStatusTableSchema,
            dataKey: 'lexusDealerDetails'
        },
        {
            title: "Primary Job Enrollment Status",
            schema: LexusEnrollmentStatusTableSchema,
            dataKey: 'lexusPrimaryJobDetails'
        },
        {
            title: "Secondary Job Roles",
            schema: LexusSecondaryJobRoleTableSchema,
            dataKey: 'lexusSecondaryJobDetails'
        },
        {
            title: "Lexus Certification Details",
            schema: LexusCertificationDetailsTableSchema,
            dataKey: 'lexusCertDetails'
        }
    ]
}

export const JobHistoryDetailComponentToyotaTableSchema: jobHistoryDetailTableSchema = {
    headerLabel: "TOYOTA",
    tableSchemaArray: [
        {
            title: "Associate Summary",
            schema: ToyotaAssociateSummaryTableSchema, 
            dataKey: 'toyotaAssociateDetails'
        },
        {
            title: "Dealer Status",
            schema: ToyotaDealerStatusTableSchema,
            dataKey: 'toyotaDealerDetails'
        },
        {
            title: "Primary Job Enrollment Status",
            schema: ToyotaEnrollmentStatusTableSchema,
            dataKey: 'toyotaPrimaryJobDetails'
        },
        {
            title: "Secondary Job Roles",
            schema: ToyotaSecondaryJobRoleTableSchema,
            dataKey: 'toyotaSecondaryJobDetails'
        },
        {
            title: "Toyota Certification Details",
            schema: ToyotaCertificationDetailsTableSchema,
            dataKey: 'toyotaCertDetails'
        }
    ]
}

export const JobHistoryDetailComponentTTENTableSchema: jobHistoryDetailTableSchema = {
    headerLabel: "T-TEN",
    tableSchemaArray: [
        {
            title: "",
            schema: TTENTableSchema, 
            dataKey: 'toyotaTtenDetails'
        }
    ]
}

export const JobHistoryExportFileName = 'JobHistoryDetail'
export const JobHistoryDetailSearchConfig: SearchConfig = {
    path: "jobHistoryForSpinId",
    method: FETCH_METHODS['Get'],
    body: {
        [FieldNames['SpinId']]: "",
        'associateType': ''
    }
} 